import React from "react";
import { connect } from "react-redux";

import Layout from "../components/Layout/Layout.react";
import FunctionalAreaTable from "../components/FunctionalAreaTable";
import HomeSearchPanel from "../components/HomeSearchPanel";
import JobsByLocationSection from "../components/job-board/jobs-by-location-section";
import RecentlyPostedJobsSection from "../components/job-board/recently-posted-jobs-section";
import { getFunctionalAreaFacets, getLocationFacets, listJobs } from "../lib/server/hirexlGlobalJobBoardClient";

const Home = ({ functionalArea, functionalAreaError, locations, locationsError, recentJobs, recentJobsError, cities, functionalAreaSearch }) => (
  <Layout
    title={"No. 1 Job portal for startups and Edtech| All Good Jobs "}
    description={
      "All Good Jobs - Academic Jobs Curriculum Designing Jobs Education Industry Jobs Edtech Jobs Teaching vacancies"
    }
  >
    <React.Fragment>
      <HomeSearchPanel locations={locations} />
      <RecentlyPostedJobsSection initialJobs={recentJobs} initialError={recentJobsError} />
      <FunctionalAreaTable functionalArea={functionalArea} initialError={functionalAreaError} />
      <JobsByLocationSection initialLocations={locations} initialError={locationsError} />
    </React.Fragment>
  </Layout>
);

export async function getServerSideProps() {
  const [jobs, functionalArea, locations] = await Promise.all([
    listJobs({ page: 1, limit: 6 }).catch(() => null),
    getFunctionalAreaFacets().catch(() => null),
    getLocationFacets().catch(() => null),
  ]);

  return {
    props: {
      functionalAreaSearch: [],
      functionalArea: functionalArea || [],
      functionalAreaError: functionalArea === null,
      locations: locations || [],
      locationsError: locations === null,
      recentJobs: jobs?.hits || [],
      recentJobsError: jobs === null,
      cities: [],
    },
  };
}

export default Home;
